import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { ApiHandlerDiscreteParameter, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { SubmitContactUsFormApiParameter } from "@insite/client-framework/Services/EmailService";
import {chain, PopulateApiParameter} from '@insite/client-framework/Store/Components/ContactUsForm/Handlers/SubmitContactForm';

type SubmitContactFormParameter = {
    emailRecipients: string;
} & HasOnSuccess;

type HandlerType = ApiHandlerDiscreteParameter<SubmitContactFormParameter, SubmitContactUsFormApiParameter>;

const PopulateAdditionalApiParameters: HandlerType = props => {
    const state = props.getState().components.contactUsForm;
    props.apiParameter = { ...props.apiParameter, ...state.fieldValues };
}

addToChainAfter(chain, PopulateApiParameter, PopulateAdditionalApiParameters)